<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        md="12"
        class="text-left"
      >
        <h5>훈련 정도(Training)</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-form-group>
          <b-form-checkbox-group
            id="trainig"
            v-model="selected"
            :disabled="freezing"
            name="traning"
            :options="options"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../../api'

export default {
  name: 'RemnantTraning',
  props: {
    email: {
      type: String,
      required: true
    },
    readOnly: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      selected: [],
      options: api.TRAININGLIST
    }
  },
  computed: {
    freezing () {
      return this.readOnly
    }
  },
  mounted () {
    if (this.email !== '') {
      this.getDetailInfo(1)
    }
  },
  methods: {
    alertNotFound () {
      alert('등록된 정보가 없습니다!')
    },
    exportData (postArg) {
      postArg['training'] = this.selected
      return postArg
    },
    parseDetailInfo (data) {
      this.selected = data.training
    },
    getDetailInfo (info) {
      if (this.errors.has('email')) {
        this.alertRetryEmail()
        return
      }
      api.request('get', '/remnant/check?' + 'email=' + this.email + '&ic=training&info=' + info)
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          if (data.check === 1 && info === 1) {
            // 로그인 후 정보수정으로 들어옴
            this.parseDetailInfo(data)
            // email잠구자
          } else {
            // insert
            // this.alertNotFound()
          }
        })
      this.$validator.reset()
    }
  }
}
</script>

<style>
</style>
